import * as React from "react";

import HelpIcon from "@mui/icons-material/Help";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import CloseableDialogTitle from "../common/CloseableDialogTitle";
import useIntercom from "../hooks/useIntercom";

import useDialog from "./useDialog";

interface Props {
    onDone: () => void;
}

export default function ReportIssueConfirmed({
    onDone,
}: Props): React.JSX.Element {
    const { setDialogType } = useDialog();
    const intercom = useIntercom();
    return (
        <>
            <CloseableDialogTitle onClose={() => setDialogType("Device")}>
                Issue Reported
            </CloseableDialogTitle>
            <DialogContent>
                Your issue has been reported. Thank you for your feedback.
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        intercom.newMessage();
                        onDone();
                    }}
                    startIcon={<HelpIcon />}
                    variant="contained"
                    color="secondary"
                >
                    Contact Support
                </Button>
                <Button onClick={onDone} color="primary" variant="contained">
                    Done
                </Button>
            </DialogActions>
        </>
    );
}
